/* HEADER LOGIC */
//This Javascript is used to handle scripts related to the nav bar, including displaying kids and baby menu


// Run function on window load
window.onload= onload_code ();


// Function to remove classlist to hide submenus until window loads completely
function onload_code (){

  const womenRemove = document.querySelector('#women-menu-nav');
  womenRemove.classList.remove("hide");
  
  const menRemove = document.querySelector('#men-menu-nav');
  menRemove.classList.remove("hide");
  


  const languageIcons = document.querySelectorAll('.language_icon');

  languageIcons.forEach(icon => {
    icon.classList.remove('hide');
  });

}


// function to hide other submenus when one is active
$(document).ready(function () {

  var currentLanguageOption = localStorage.getItem("language");
  var languageIconClasses = {
  "en": ".language_icon_en",
  "de": ".language_icon_de",
  "nl": ".language_icon_nl",
  "es": ".language_icon_es",
  "fr": ".language_icon_fr",
  "it": ".language_icon_it",
  "sv": ".language_icon_sv",
  "pt": ".language_icon_pt",
  "fi": ".language_icon_fi",
  "no": ".language_icon_no",
  "pl": ".language_icon_pl",
  "el": ".language_icon_el"
    
  };

  if (currentLanguageOption in languageIconClasses) {
    $(".language_icon").hide();
    $(languageIconClasses[currentLanguageOption]).show();
  }

  user_option = localStorage.getItem("header_category");

  if(user_option === "Women"){
    $("#parents_button_women").css('border-bottom','2px solid black');
    $("#parents_button_men").css('border-bottom','none');
    $("#parents_button_baby").css('border-bottom','none');
    $("#parents_button_kids").css('border-bottom','none');
    $("#women-menu-nav").show();
    $("#men-menu-nav").hide();
    $("#kids-menu-nav").hide();
    $("#baby-menu-nav").hide();
  }
  else if (user_option === "Men"){
    $("#parents_button_men").css('border-bottom','2px solid black');
    $("#parents_button_women").css('border-bottom','none');
    $("#parents_button_baby").css('border-bottom','none');
    $("#parents_button_kids").css('border-bottom','none');
    $("#women-menu-nav").hide();
    $("#men-menu-nav").show();
    $("#kids-menu-nav").hide();
    $("#baby-menu-nav").hide();
  }  

  else if (user_option === "kids"){
    $("#parents_button_kids").css('border-bottom','2px solid black');
    $("#parents_button_women").css('border-bottom','none');
    $("#parents_button_men").css('border-bottom','none');
    $("#parents_button_baby").css('border-bottom','none');
    $("#women-menu-nav").hide();
    $("#men-menu-nav").hide();
    $("#kids-menu-nav").show();
    $("#baby-menu-nav").hide();
    
    
  }  

  else {
    $("#parents_button_baby").css('border-bottom','2px solid black');
    $("#parents_button_women").css('border-bottom','none');
    $("#parents_button_men").css('border-bottom','none');
    $("#parents_button_kids").css('border-bottom','none');
    $("#women-menu-nav").hide();
    $("#men-menu-nav").hide();
    $("#baby-menu-nav").show();
    $("#kids-menu-nav").hide();
    
    
  }   
 
  //Change language on click
  $('.mobile-change-language-button, .dropdown-menu li').on('click', function() {
    var currentLanguage = localStorage.getItem("language");
    var selectedLanguage = $(this).attr('lang');

    if(currentLanguage === selectedLanguage){
      return;
    }
    localStorage.setItem("language",selectedLanguage)
    location.reload()
  });
  
// function to hide other submenus when one is clicked and active
  $(".utils__parent__category").click(function (event) {
    parent_category = $(this).val();
    currentHeaderCategory = localStorage.getItem("header_category");
    if(parent_category === currentHeaderCategory){
      return;
    }else if(parent_category === "Women") {
      $("#kids-menu-nav").fadeOut(300, function () {
        $("#women-menu-nav").fadeIn(300);

        // When you click on the other nav tabs in a different order, hide others they would not overlap
        $("#men-menu-nav").css('display','none');
        $("#kids-menu-nav").css('display','none');
        $("#baby-menu-nav").css('display','none');
        
        $("#parents_button_women").css('border-bottom','2px solid black');
        $("#parents_button_men").css('border-bottom','none');
        $("#parents_button_baby").css('border-bottom','none');
        $("#parents_button_kids").css('border-bottom','none');
        localStorage.setItem("header_category","Women");
      });
      }else if(parent_category === "Men") {
      $("#women-menu-nav").fadeOut(300, function () {
        $("#men-menu-nav").fadeIn(300);

        // When you click on the other nav tabs in a different order, hide others they would not overlap
        $("#women-menu-nav").css('display','none');
        $("#kids-menu-nav").css('display','none');
        $("#baby-menu-nav").css('display','none');
        
        $("#parents_button_men").css('border-bottom','2px solid black');
        $("#parents_button_women").css('border-bottom','none');
        $("#parents_button_baby").css('border-bottom','none');
        $("#parents_button_kids").css('border-bottom','none');
        localStorage.setItem("header_category","Men");
      });
      } else if(parent_category === "Baby") {
      $("#men-menu-nav").fadeOut(300, function () {
        $("#baby-menu-nav").fadeIn(300);

        // When you click on the other nav tabs in a different order, hide others they would not overlap
        $("#women-menu-nav").css('display','none');
        $("#men-menu-nav").css('display','none');
        $("#kids-menu-nav").css('display','none');
        
        $("#parents_button_baby").css('border-bottom','2px solid black');
        $("#parents_button_women").css('border-bottom','none');
        $("#parents_button_men").css('border-bottom','none');
        $("#parents_button_kids").css('border-bottom','none');
        localStorage.setItem("header_category","Baby");
      });
    } else {
      $("#baby-menu-nav").fadeOut(300, function () {
        $("#kids-menu-nav").fadeIn(300);

        // When you click on the other nav tabs in a different order, hide others they would not overlap
        $("#women-menu-nav").css('display','none');
        $("#men-menu-nav").css('display','none');
        $("#baby-menu-nav").css('display','none');
          
        $("#parents_button_kids").css('border-bottom','2px solid black');
        $("#parents_button_women").css('border-bottom','none');
        $("#parents_button_men").css('border-bottom','none');
        $("#parents_button_baby").css('border-bottom','none');
        localStorage.setItem("header_category","Kids");
      });
    }
  });
});